import { useAtomValue } from 'jotai';

import { companyAtom } from '@/atoms/company';
import { Locale } from '@/constants/Locale';

export const useCompanyAvailableLanguages = (): string[] => {
    const company = useAtomValue(companyAtom);
    const availableLanguages = company?.company.availableLanguages;

    return availableLanguages && availableLanguages.length > 0 ? availableLanguages : [Locale.EN];
};
